import { render, staticRenderFns } from "./image-swiper.vue?vue&type=template&id=510cde90&scoped=true"
import script from "./image-swiper.vue?vue&type=script&lang=js"
export * from "./image-swiper.vue?vue&type=script&lang=js"
import style0 from "./image-swiper.vue?vue&type=style&index=0&id=510cde90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cde90",
  null
  
)

export default component.exports